import { footerPosition, observer } from "./footer"

window.addEventListener('DOMContentLoaded', (event) => {
  // slider
  const slideWrappers = document.querySelectorAll(
    '.scrollableShopListWrapper.horizontal'
  )
  slideWrappers.forEach((slideWrapper) => {
    const ul = slideWrapper.querySelector('ul')
    const is3column = slideWrapper.classList.contains('threeColumn')
    const children = Array.from(ul.children)
    const slide = KeenSlider(ul, {
      slides: {
        perView: is3column ? 3 : 2,
        spacing: 24
      },
      selector: children,
      breakpoints: {
        '(max-width: 768px)': {
          slides: {
            perView: 1,
            spacing: 10
          }
        }
      }
    })
    const arrows = slideWrapper.querySelectorAll('.arrow')
    arrows.forEach((arrow) => {
      const isNext = arrow.classList.contains('next')
      arrow.addEventListener('click', isNext ? slide.next : slide.prev)
    })
  })

  // like
  // const shopCards = document.querySelectorAll('.shopCard, .newsCard')
  // shopCards.forEach((shopCard) => {
  //   const likeButton = shopCard.querySelector('.like')
  //   likeButton.addEventListener('click', () => {
  //     shopCard.classList.toggle('liked')
  //   })
  // })

  // aside追従
  const twoColumnSideBar = document.querySelector('.twoColumn aside')
  const chaseScrollAside = () => {
    const breadcrumb = document.querySelector('nav.breadcrumb')
    const scroll = window.pageYOffset
    const breadcrumbBeyond =
      breadcrumb.offsetTop +
      breadcrumb.clientHeight -
      (scroll + window.innerHeight)
    const breadcrumbOffsetBottomOnScreen =
      breadcrumbBeyond > 0 ? 0 : breadcrumbBeyond
    twoColumnSideBar.style.transform = `translateY(${
      scroll + breadcrumbOffsetBottomOnScreen
    }px)`
  }
  const clearScrollAside = () => {
    twoColumnSideBar.style.transform = null
  }
  const mqChangesListener = (e) => {
    if (e.matches) {
      document.addEventListener('scroll', chaseScrollAside)
    } else {
      clearScrollAside()
      document.removeEventListener('scroll', chaseScrollAside)
    }
  }
  const mediaQuery = window.matchMedia('(min-width:769px)')
  if (twoColumnSideBar) {
    mediaQuery.addEventListener('change', mqChangesListener)
    mqChangesListener(mediaQuery)
  }

  // .categoryChips.scroll
  // const categoryChipsScroll = document.querySelector('.categoryChips.scroll')
  // if (categoryChipsScroll) {
  //   const chipsArray = Array.from(categoryChipsScroll.children)
  //   const targetSelector = categoryChipsScroll.dataset.targets
  //   const targets = document.querySelectorAll(targetSelector)
  //   const targetsArray = Array.from(targets)
  //   const ratios = targetsArray.map((target) => 0)
  //   let maxIndex = 0
  //   targetsArray.forEach((target, i) => {
  //     const observer = new IntersectionObserver(
  //       (entries) => {
  //         ratios[i] = entries[0].intersectionRatio
  //         const max = Math.max(...ratios)
  //         maxIndex = ratios.indexOf(max)
  //         chipsArray.forEach((chip, i) => {
  //           if (i === maxIndex) {
  //             chip.children[0].classList.add('selected')
  //           } else {
  //             chip.children[0].classList.remove('selected')
  //           }
  //         })
  //       },
  //       {
  //         root: null,
  //         threshold: [0, 0.25, 0.5, 0.75, 1]
  //       }
  //     )
  //     observer.observe(target)
  //   })
  //   chipsArray.forEach((chip, i) => {
  //     chip.addEventListener('click', (e) => {
  //       targetsArray[i].scrollIntoView({ behavior: 'smooth' })
  //     })
  //   })
  // }

  // expander
  document.querySelectorAll('.expander').forEach((elm) => {
    const title = elm.querySelector('.title')
    const content = elm.querySelector('.content')
    content.dataset.height = `${content.clientHeight}px`
    content.style.height = 0
    title.addEventListener('click', () => {
      const classList = elm.classList
      const closed = classList.contains('closed')
      classList.toggle('closed')
      if (closed) {
        content.style.height = content.dataset.height
      } else {
        content.style.height = 0
      }
    })
    elm.classList.add('closed')
  })

  // search
  // const searchForm = document.querySelector('.search')
  // if (searchForm) {
  //   const queryString = window.location.search
  //   const urlParams = new URLSearchParams(queryString)
  //   const searchWord = urlParams.get('search_word')
  //   const searchInput = document.querySelector('input[name="search_word"]')
  //   if (searchInput) {
  //     searchInput.value = searchWord
  //   }
  // }

  // ブラウザバック
  const backButton = document.querySelector('#globalNav.onlyLogo .backButton')
  if (backButton) {
    backButton.addEventListener('click', function() {
      history.back()
    })
  }

  // mypageModal
  const mypageModal = document.getElementById('mypageModal')
  if (mypageModal) {
    mypageModal.addEventListener('click', function(event) {
      const mypageModalOverlay = document.querySelector('.mypage-modal-overlay')
      if (mypageModalOverlay.style.display === 'none') {
        mypageModalOverlay.style.display = 'block'
      } else {
        mypageModalOverlay.style.display = 'none'
      }
    })

    // モーダルの外側がクリックされたらモーダルを閉じる
    const modalOverlay = document.querySelector('.mypage-modal-overlay')
    if (modalOverlay) {
      window.onclick = function(e) {
        if (e.target === modalOverlay) {
          modalOverlay.style.display = 'none'
        }
      }
    }
  }

  let submitForms = document.querySelectorAll('form');
  submitForms.forEach((submitForm) => {
    let submitButton = submitForm.querySelectorAll('input[type=submit], button[type=submit]');
    if (submitButton.length) {
      submitForm.addEventListener('submit', function(event) {
        event.preventDefault();
        if (submitButton.disabled) {
          return false;
        }
        // 対応する送信ボタンを無効化
        submitButton.disabled = true;
        submitForm.submit();
        setTimeout(() => {
          submitButton.disabled = false;
        }, 5000);
      });
    }
  });

  // header
  const globalNav = document.getElementById('globalNav')
  const navList = document.getElementById('navList')
  if (navList) {
    const link_url = location.pathname + location.search
    // article
    if (location.href.includes('article')) {
      const articleTab = document.querySelector('.articleTab')
      articleTab.classList.add('active')
    }
    // movie
    if (location.href.includes('movie')) {
      const movieTab = document.querySelector('.movieTab')
      movieTab.classList.add('active')
    }
    // gift
    if (location.href.includes('gift')) {
      const giftTab = document.querySelector('.giftTab')
      giftTab.classList.add('active')
    }
    // shop
    if (link_url.match(/^\/shop\/26/) || link_url === '/shop?id=26') {
      const hotelTab = document.querySelector('.hotelTab')
      if (hotelTab) {
        hotelTab.classList.add('active')
      }

    } else if (location.href.includes('shop')) {
      const shopTab = document.querySelector('.shopTab')
      shopTab.classList.add('active')
    }
    // aloco_news
    if (location.href.includes('aloco_news')) {
      globalNav.classList.add('noSearch')
      const alocoNewsTab = document.querySelector('.alocoNewsTab')
      alocoNewsTab.classList.add('active')
      const alocoNewsAction = document.querySelector('.alocoNewsAction')
      if (alocoNewsAction) {
        alocoNewsAction.classList.add('active')
      }
    }
  }
  ellipsisText()
  footerPosition()
})

window.addEventListener('resize', (event) => {
  ellipsisText()
  footerPosition()
})

document.addEventListener('click', function(event) {
  footerPosition()
  observer()
})

function ellipsisText() {
  const ellipsisText = document.querySelector(".ellipsis-text")
  if (ellipsisText) {
    if (ellipsisText.scrollHeight > ellipsisText.clientHeight) {
      let readMoreLink = ellipsisText.querySelector(".read-more-link")
      if (readMoreLink) return
      readMoreLink = document.createElement("a")
      readMoreLink.href = "#"
      readMoreLink.className = "read-more-link"
      readMoreLink.textContent = "...続きを読む"

      ellipsisText.appendChild(readMoreLink)

      readMoreLink.addEventListener("click", function(event) {
        event.preventDefault()
        ellipsisText.style.display = "block"
        readMoreLink.style.display = "none"
      })
    } else {
      const readMoreLink = ellipsisText.querySelector(".read-more-link")
      if (readMoreLink) {
        readMoreLink.parentNode.removeChild(readMoreLink)
      }
    }
  }
}
